import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0550. 発注案件削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
};
const destroyPurchaseOrder = (props: Props): Promise<any> => {
  return axios.delete(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}`);
};

export const useDestroyPurchaseOrder = () => {
  return useMutation({
    mutationFn: destroyPurchaseOrder,
  });
};
